var _rect, _rect2, _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCareerTech9(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.333008,
    y: 0.666748,
    width: 46,
    height: 46,
    rx: 8,
    fill: "#3E6BB2"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_19161)"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 22,
    transform: "translate(13.333 13.6667)",
    fill: "#3E6BB2"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_19161",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 14,
    width: 19,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.3539 14.6792H14.2656V33.0055H32.3539V14.6792Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_19161)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.0776 24.605C26.9796 24.605 26.8967 24.6738 26.8817 24.7654L26.7385 25.7733C26.5124 25.8726 26.2938 25.9948 26.0978 26.1322L25.1633 25.7504C25.0804 25.7504 24.9824 25.7504 24.9296 25.8497L24.176 27.1707C24.1307 27.2547 24.1458 27.354 24.2212 27.415L25.0201 28.0412C25.005 28.171 24.9975 28.2932 24.9975 28.423C24.9975 28.5528 25.005 28.675 25.0201 28.8048L24.2212 29.4309C24.1533 29.492 24.1307 29.5913 24.176 29.6753L24.9296 30.9963C24.9749 31.0956 25.0728 31.0956 25.1633 31.0956L26.0978 30.7138C26.2938 30.8512 26.5048 30.9811 26.7385 31.0727L26.8817 32.0806C26.8967 32.1722 26.9721 32.241 27.0776 32.241H28.585C28.6679 32.241 28.7508 32.1722 28.7659 32.0806L28.9091 31.0727C29.1352 30.9734 29.3387 30.8512 29.5422 30.7138L30.4692 31.0956C30.5671 31.0956 30.6651 31.0956 30.7179 30.9963L31.4716 29.6753C31.5168 29.5913 31.4942 29.492 31.4264 29.4309L30.6199 28.8048C30.635 28.675 30.65 28.5528 30.65 28.423C30.65 28.2932 30.6425 28.171 30.6199 28.0412L31.4188 27.415C31.4866 27.354 31.5092 27.2547 31.464 27.1707L30.7104 25.8497C30.6651 25.7504 30.5671 25.7504 30.4692 25.7504L29.5422 26.1322C29.3387 25.9948 29.1352 25.865 28.9015 25.7733L28.7583 24.7654C28.7508 24.6738 28.6679 24.605 28.585 24.605H27.0776ZM27.8313 27.2776C28.4568 27.2776 28.9618 27.7892 28.9618 28.423C28.9618 29.0568 28.4568 29.5684 27.8313 29.5684C27.1982 29.5684 26.7008 29.0568 26.7008 28.423C26.7008 27.7892 27.2057 27.2776 27.8313 27.2776ZM21.8019 18.4963H23.3092V20.0235H21.8019V18.4963ZM26.3239 20.0235H24.8166V18.4963H26.3239V20.0235ZM24.8166 21.5506H26.3239V23.0778H24.8166V21.5506ZM21.8019 21.5506H23.3092V23.0778H21.8019V21.5506ZM24.1458 32.241H15.7725V15.4419H29.3387V23.2993C28.8638 23.1618 28.3589 23.0778 27.8313 23.0778V16.9691H17.2798V30.7138H21.8019V28.0412H22.5782C22.5556 28.171 22.5556 28.2932 22.5556 28.423C22.5556 29.9196 23.166 31.2712 24.1458 32.241ZM20.2945 26.1322H18.7872V24.605H20.2945V26.1322ZM20.2945 23.0778H18.7872V21.5506H20.2945V23.0778ZM20.2945 20.0235H18.7872V18.4963H20.2945V20.0235ZM18.7872 27.6594H20.2945V29.1866H18.7872V27.6594ZM21.8019 24.605H23.3092V25.6817C23.2263 25.8268 23.1434 25.9795 23.0681 26.1322H21.8019V24.605Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_19161"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 22,
    fill: "white",
    transform: "translate(13.333 13.6667)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCareerTech9);
export default __webpack_public_path__ + "static/media/careerTech9.899f171446f9d2d0e6fd5ce59fe09ceb.svg";
export { ForwardRef as ReactComponent };